"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var coupon_items_1 = require("../coupon-items");
var Suggest_1 = __importDefault(require("./Suggest"));
function CouponOMTwo(props) {
    var style = props.style, className = props.className, title = props.title, icon = props.icon, list = props.list, buttonText = props.buttonText, price = props.price, suggest = props.suggest, onClick = props.onClick, extendProps = props.extendProps;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var ref = (0, react_1.useRef)(null);
    function renderBottomDetai() {
        if (!suggest) {
            return null;
        }
        return react_1.default.createElement(Suggest_1.default, __assign({}, suggest));
    }
    // pc端样式
    function renderPC() {
        return (react_1.default.createElement("div", { className: "coupon-om-pc" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('om-top', { 'om-shadow': !!suggest }) },
                react_1.default.createElement("div", { className: "om-left" },
                    react_1.default.createElement(coupon_items_1.IconTitle, { title: title, icon: icon }),
                    react_1.default.createElement(coupon_items_1.CheckList, { list: list })),
                react_1.default.createElement(coupon_items_1.Snap, null),
                react_1.default.createElement("div", { className: "om-right" },
                    react_1.default.createElement("div", { className: "om-title" }, price),
                    react_1.default.createElement("button", __assign({ onClick: onClick, className: "om-button" }, extendProps), buttonText))),
            renderBottomDetai()));
    }
    // 移动端样式
    function renderMobile() {
        return (react_1.default.createElement("div", { className: "coupon-om-mobile" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('om-top', { 'om-shadow': !!suggest }) },
                react_1.default.createElement("div", { className: "om-left" },
                    react_1.default.createElement(coupon_items_1.IconTitle, { title: title, icon: icon }),
                    react_1.default.createElement("div", { className: "om-title" }, price),
                    react_1.default.createElement(coupon_items_1.CheckList, { list: list })),
                react_1.default.createElement(coupon_items_1.Snap, { isMobile: true }),
                react_1.default.createElement("div", { className: "om-right" },
                    react_1.default.createElement("button", { onClick: onClick, className: "om-button" }, buttonText))),
            renderBottomDetai()));
    }
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-coupon-om"), className), ref: ref },
        renderMobile(),
        renderPC()));
}
exports.default = CouponOMTwo;
//# sourceMappingURL=CouponOMTwo.js.map